import { apiErrorSchema } from './responses';

/**
 * Normalised API error. Branch on {@link ApiError.code} and {@link ApiError.status},
 * never on the (mutable, localised) message text. See backend docs/frontend/05-errors.
 */
export class ApiError extends Error {
  readonly code: string;
  readonly status: number;

  constructor(code: string, message: string, status: number) {
    super(message);
    this.name = 'ApiError';
    this.code = code;
    this.status = status;
  }

  get isUnauthorized(): boolean {
    return this.status === 401;
  }
  get isForbidden(): boolean {
    return this.status === 403;
  }
  get isNotFound(): boolean {
    return this.status === 404;
  }
  get isConflict(): boolean {
    return this.status === 409;
  }
}

/** Convert an openapi-fetch error payload + status into a typed {@link ApiError}. */
export function toApiError(error: unknown, status: number): ApiError {
  const parsed = apiErrorSchema.safeParse(error);
  if (parsed.success) {
    return new ApiError(parsed.data.error.code, parsed.data.error.message, status);
  }
  return new ApiError('unknown_error', 'An unexpected error occurred.', status);
}
